// SCROLL TOP

window.addEventListener("scroll", function() {
  var elementTarget = document.getElementById("bookMarker");
  if(elementTarget) {
    if (window.scrollY > (elementTarget.offsetTop + elementTarget.offsetHeight)) {
      // console.log("You've scrolled past the div");
      $('.desktop-book').addClass('hide');
    } else {
      $('.desktop-book').removeClass('hide');
    }
  }
});

$(document).ready(function() {
  $('#submitReviewBtn').on('click', function() {
    $('.globo-formbuilder').toggleClass('hide');
  })
});

$(document).ready(function() {
  var url = window.location.href;
  var index = url.indexOf("#");
  if (index !== -1)
  {
      var hash = url.substring(index + 1);
      console.log(hash);
      $([document.documentElement, document.body]).animate({
          scrollTop: $("#"+hash).offset().top - 120
      },0);
  }
    
  $('.menu-scroll').click(function() {
    var scroll_to_div = $(this).attr('data-scroll');
    console.log('menu-scroll clicked = ' + scroll_to_div);
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#"+scroll_to_div).offset().top - 120
    },0);
  });

  $('.product-image-scroll').click(function() {
    var scroll_to_div = $(this).attr('data-image-scroll');
    console.log('product-image-scroll clicked = ' + scroll_to_div);
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#"+scroll_to_div).offset().top - 120
    },0);
  });
});


// PRODUCT PAGE 

function openTab(evt, tabName) {
    // Declare all variables
    var i, tabcontent, tablinks;

    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("book-tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    // Show the current tab, and add an "active" class to the link that opened the tab
    document.getElementById(tabName).style.display = "block";
    evt.currentTarget.className += " active";
}

// 3D BOOK

// LottieInteractivity.create({
//     player: '#dearLoveBook',
//     mode: 'cursor',
//     actions: [
//         {
//             position: { x: [0, 1], y: [-1, 2] },
//             type: 'seek',
//             frames: [30, 90],
//         }
//     ]
// });

// FALLING ROSES

// FALLING ROSES

var falling = true;

var total_left = 10;
var total_right = 10;
var containerLeft = document.getElementById("rosesFallingLeft");
var containerRight = document.getElementById("rosesFallingRight")
var w = document.getElementById("rosesFallingLeft").offsetWidth;
var h = document.getElementById("rosesFallingRight").offsetHeight;

// FALLING LEFT
for (i=0; i<total_left; i++){ 
   var rose_div = document.createElement('div');
   rose_div.setAttribute('id', 'rose_left_'+i);
   const sizes = [60, 100, 60, 100, 140, 180];
   const z = [0, 0, 0, 0, 0, 0];
   const random = Math.floor(Math.random() * sizes.length);
   rose_div.style.width = sizes[random] + 'px';
   rose_div.style.height = sizes[random] + 'px';
   rose_div.style.zIndex = z[random];

   TweenLite.set(rose_div,{attr:{class:'roses'},x:R(0,w),y:R(-200,-150),z:R(-200,200)});
   containerLeft.appendChild(rose_div);
   animmLeft(rose_div, i);
}

// FALLING RIGHT
for (i=0; i<total_right; i++){ 
   var rose_div = document.createElement('div');
   rose_div.setAttribute('id', 'rose_right_'+i);
   const sizes = [60, 100, 60, 100, 140, 180];
   const z = [0, 0, 0, 0, 0, 0];
   const random = Math.floor(Math.random() * sizes.length);
   rose_div.style.width = sizes[random] + 'px';
   rose_div.style.height = sizes[random] + 'px';
   rose_div.style.zIndex = z[random];

   TweenLite.set(rose_div,{attr:{class:'roses'},x:R(0,w),y:R(-200,-150),z:R(-200,200)});
   containerRight.appendChild(rose_div);
   animmRight(rose_div);
}
 
function animmLeft(element, identifier){ 
	var verticalTime = R(6,15);
	TweenMax.to(element,verticalTime,{y:h+100,ease:Linear.easeNone,repeat:-1,delay:-15});
    TweenMax.to(element,R(6,10),{x:'-=100',rotationZ:R(-90,90),repeat:-1,yoyo:true,ease:Sine.easeInOut});
    TweenMax.to(element,R(4,10),{rotationX:R(-45,45),rotationY:R(0,0),repeat:-1,yoyo:true,ease:Sine.easeInOut,delay:-5});
};

function animmRight(element){   
   TweenMax.to(element,R(6,15),{y:h+100,ease:Linear.easeNone,repeat:-1,delay:-15});
   TweenMax.to(element,R(6,10),{x:'+=100',rotationZ:R(-90,90),repeat:-1,yoyo:true,ease:Sine.easeInOut});
   TweenMax.to(element,R(4,10),{rotationX:R(-45,45),rotationY:R(0,0),repeat:-1,yoyo:true,ease:Sine.easeInOut,delay:-5});
};

function R(min,max) {return min+Math.random()*(max-min)};

// GSAP BOOK INFO 
gsap.registerPlugin(ScrollTrigger);

gsap.fromTo(".rose-li-home li",
  {
    y: 30,
    opacity: -90,
  },
  {
    y: 0,
    stagger: 0.5,
    opacity: 1,
    scrollTrigger: {
      pin: ".book-block-2",
      markers: false,
      scrub: true,
	  toggleActions: "play none none none",
      start: "top top",
      invalidateOnRefresh: true
    }
  }
);


gsap.fromTo(".fade-in",
  {
    y: 30,
    opacity: 0,
  },
  {
    y: 0,
    stagger: 0.5,
    opacity: 1,
    scrollTrigger: {
      pin: ".book-block-3",
      markers: false,
      scrub: true,
	  toggleActions: "play none none none",
      start: "top top",
      invalidateOnRefresh: true
    }
  }
);


// BOOK POSITION

window.addEventListener('scroll', function() {
  var book_marker = document.querySelector('#bookMarker');
  var book_marker_position = book_marker.getBoundingClientRect();
  // checking for partial visibility
  
  if(book_marker_position.bottom < window.innerHeight && book_marker_position.bottom >= 0) {
    $('.bookHighlight_desktop').removeClass('highlight');
  } else {
  	if(book_marker_position.y < 0) {

	} else {
		$('.bookHighlight_desktop').addClass('highlight');
	}
    
  }
});

// ADD CODE FOR ON PAGE LOAD IF AT THE BOTTOM ALREADY


// FALLING ROSES MOBILE

var falling_mobile = true;

var total_left_mobile = 10;
var total_right_mobile = 10;
var containerLeft_mobile = document.getElementById("rosesFallingLeft_mobile");
var containerRight_mobile = document.getElementById("rosesFallingRight_mobile")
var w_mobile = document.getElementById("rosesFallingLeft_mobile").offsetWidth;
var h_mobile = document.getElementById("rosesFallingRight_mobile").offsetHeight;

// FALLING LEFT
for (i=0; i<total_left_mobile; i++){ 
   var rose_div = document.createElement('div');
   rose_div.setAttribute('id', 'rose_left_mobile_'+i);
   const sizes = [60, 100, 60, 100, 140, 180];
   const z = [0, 0, 0, 0, 0, 0];
   const random = Math.floor(Math.random() * sizes.length);
   rose_div.style.width = sizes[random] + 'px';
   rose_div.style.height = sizes[random] + 'px';
   rose_div.style.zIndex = z[random];

   TweenLite.set(rose_div,{attr:{class:'roses'},x:RMobile(0,w_mobile),y:RMobile(-200,-150),z:RMobile(-200,200)});
   containerLeft_mobile.appendChild(rose_div);
   animmLeftMobile(rose_div, i);
}

// FALLING RIGHT
for (i=0; i<total_right_mobile; i++){ 
   var rose_div = document.createElement('div');
   rose_div.setAttribute('id', 'rose_right_mobile_'+i);
   const sizes = [60, 100, 60, 100, 140, 180];
   const z = [0, 0, 0, 0, 0, 0];
   const random = Math.floor(Math.random() * sizes.length);
   rose_div.style.width = sizes[random] + 'px';
   rose_div.style.height = sizes[random] + 'px';
   rose_div.style.zIndex = z[random];

   TweenLite.set(rose_div,{attr:{class:'roses'},x:RMobile(0,w_mobile),y:RMobile(-200,-150),z:RMobile(-200,200)});
   containerRight_mobile.appendChild(rose_div);
   animmRightMobile(rose_div);
}

function animmLeftMobile(element, identifier){ 
	var verticalTime = R(6,15);
	TweenMax.to(element,verticalTime,{y:h_mobile+100,ease:Linear.easeNone,repeat:-1,delay:-15});
    TweenMax.to(element,R(6,10),{x:'-=100',rotationZ:R(-90,90),repeat:-1,yoyo:true,ease:Sine.easeInOut});
    TweenMax.to(element,R(4,10),{rotationX:R(-45,45),rotationY:R(0,0),repeat:-1,yoyo:true,ease:Sine.easeInOut,delay:-5});
};

function animmRightMobile(element){   
   TweenMax.to(element,R(6,15),{y:h_mobile+100,ease:Linear.easeNone,repeat:-1,delay:-15});
   TweenMax.to(element,R(6,10),{x:'+=100',rotationZ:R(-90,90),repeat:-1,yoyo:true,ease:Sine.easeInOut});
   TweenMax.to(element,R(4,10),{rotationX:R(-45,45),rotationY:R(0,0),repeat:-1,yoyo:true,ease:Sine.easeInOut,delay:-5});
};

function RMobile(min,max) {return min+Math.random()*(max-min)};
 
